import * as pdfupload from './pdfupload/index'
export default {
    pdfupload
}